import React from "react";
import { toast } from "sonner";
import { FileSpreadsheet, FileText } from "lucide-react";
import { useApp } from "../context/AppContext";
import { GanttTimeline } from "../components/GanttTimeline";
import { GanttLegend } from "../components/GanttLegend";
import { DayNavigator } from "../components/DayNavigator";
import { PageHeader } from "../components/PageHeader";
import { Button } from "../components/ui/button";
import { exportCSV, exportPDF } from "../lib/export";

export default function SchedulePage() {
  const { config, agents, workstations, schedule, absences, professions, selectedDay } = useApp();
  if (!config) return null;

  const hasSchedule = schedule?.assignments?.length > 0;
  const run = (fn, label) => () => {
    if (!hasSchedule) return toast.error("Generate a schedule first");
    try {
      const n = fn(schedule, config, agents, workstations, professions);
      toast.success(`${label} exported`, { description: `${n} shift rows across the week.` });
    } catch (e) {
      toast.error(`${label} export failed`, { description: e.message });
    }
  };

  return (
    <div className="animate-fadeup">
      <PageHeader
        title="Gantt Timeline"
        subtitle="Every agent × every 5-minute slot for the selected day. Pick a day below; zoom to read the fine-grained grid. Coloured = workstation, dashed = meal break, hatched = absence."
      >
        <Button variant="outline" size="sm" onClick={run(exportCSV, "CSV")} disabled={!hasSchedule} data-testid="export-csv-btn">
          <FileSpreadsheet className="w-4 h-4" /> Export CSV
        </Button>
        <Button variant="outline" size="sm" onClick={run(exportPDF, "PDF")} disabled={!hasSchedule} data-testid="export-pdf-btn">
          <FileText className="w-4 h-4" /> Export PDF
        </Button>
      </PageHeader>
      <DayNavigator />
      <GanttTimeline config={config} agents={agents} workstations={workstations} schedule={schedule} absences={absences} professions={professions} day={selectedDay} />
      <GanttLegend workstations={workstations} />
    </div>
  );
}
